import * as React from 'react'
import { Text } from 'react-native'

import Root from '@components/root/Root'

const TodoScreen = () => {
  return (
    <Root centered>
      <Text>Cette fonctionnalité sera disponible prochainement.</Text>
    </Root>
  )
}

export default TodoScreen
